import { atom } from "recoil";

export const messageSoundObj = atom({
  key: "messageSound",
  default: {},
});
